import { AxiosResponse } from "axios";

import { appConstants } from "../config/app-constants";

import { IPlanAddEdit, IPlanParams, IPlansRoot } from "../config/interfaces";
import InitApi from "./init";

class PlansApi {
  static _instance: PlansApi;

  static getInstance = () => {
    if (this._instance) {
      return this._instance;
    }
    this._instance = new PlansApi();
    return this._instance;
  };

  _apiSvc;

  constructor() {
    this._apiSvc = InitApi.getInstance();
  }

  getPlans = async (params: IPlanParams): Promise<{ count: number; records: IPlansRoot[] }> => {
    const { offset = 0, count = 10, orderBy, order, type } = params;
    let url = `plan?offset=${offset}`;
    if (count) {
      url += `&count=${count}`;
    }
    if (orderBy) {
      url += `&orderBy=${orderBy}`;
    }
    if (order) {
      url += `&order=${order}`;
    }
    if (type) {
      url += `&type=${type}`;
    }
    const response = await this._apiSvc.get(`${appConstants.apiUrl}/${url}`);
    return response.data;
  };

  getPublicPlans = async (
    params: IPlanParams
  ): Promise<{ count: number; records: IPlansRoot[] }> => {
    const { offset = 0, count = 10, orderBy, order, type } = params;
    let url = `public-plan?offset=${offset}`;
    if (count) {
      url += `&count=${count}`;
    }
    if (orderBy) {
      url += `&orderBy=${orderBy}`;
    }
    if (order) {
      url += `&order=${order}`;
    }
    if (type) {
      url += `&type=${type}`;
    }
    const response = await this._apiSvc.get(`${appConstants.apiUrl}/${url}`);
    return response.data;
  };

  getEFilingPlanById = async (uuid: string): Promise<AxiosResponse> => {
    const response = await this._apiSvc.get(`${appConstants.apiUrl}/efiling-plan/single/${uuid}`);
    return response.data;
  };

  getIncomeSource = async (): Promise<AxiosResponse> => {
    return this._apiSvc.get(`${appConstants.apiUrl}/plan/income-source-list`);
  };

  getPlanById = async (uUId: string): Promise<IPlansRoot> => {
    const response = await this._apiSvc.get(`${appConstants.apiUrl}/plan/single/${uUId}`);
    return response.data;
  };

  addPlan = async (data: IPlanAddEdit): Promise<IPlansRoot> => {
    const response = await this._apiSvc.post(`${appConstants.apiUrl}/plan`, data);
    return response.data;
  };

  updatePlanById = async (uUId: string, data: IPlanAddEdit): Promise<IPlansRoot> => {
    const response = await this._apiSvc.put(`${appConstants.apiUrl}/plan/single/${uUId}`, data);
    return response.data;
  };

  deletePlan = async (data: { uuids: any[] }): Promise<AxiosResponse> => {
    return this._apiSvc.delete(`${appConstants.apiUrl}/plan`, { data });
  };

  getPricingPageSettingsByKey = async (data: { keys: any }): Promise<AxiosResponse> => {
    return this._apiSvc.get(`${appConstants.apiUrl}/global-setting/multi`, { params: data });
  };

  createPricingPageSettings = async (data: any[]): Promise<AxiosResponse> => {
    return this._apiSvc.post(`${appConstants.apiUrl}/global-setting/multi`, { data: data });
  };

  updatePricingPageSettings = async (data: any[]): Promise<AxiosResponse> => {
    return this._apiSvc.put(`${appConstants.apiUrl}/global-setting/multi`, { data: data });
  };
}
export default PlansApi;
